
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AUTH } from "@/constants/testIds";
import { LogOut, Settings as SettingsIcon, LayoutGrid } from "lucide-react";

export default function AppShell({ children, right }) {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-30 backdrop-blur-md bg-[#09090B]/80 border-b border-zinc-800">
        <div className="max-w-[1600px] mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/dashboard" className="flex items-center gap-3 group">
              <div className="h-7 w-7 rounded-sm bg-brand flex items-center justify-center font-heading text-black font-black text-base">3</div>
              <div className="hidden sm:block">
                <div className="text-[10px] tracking-[0.22em] uppercase font-bold text-zinc-500 leading-none">360 Digital Marketing</div>
                <div className="font-heading text-sm font-bold tracking-tight mt-0.5">SignFlow360™</div>
              </div>
            </Link>
            <nav className="hidden md:flex items-center gap-1 text-sm">
              <Link to="/dashboard"
                className={`px-3 py-1.5 rounded-sm inline-flex items-center gap-2 transition-colors
                ${pathname.startsWith("/dashboard") || pathname.startsWith("/projects") ? "text-white bg-zinc-900 border border-zinc-800" : "text-zinc-400 hover:text-white"}`}>
                <LayoutGrid className="w-3.5 h-3.5" /> Projects
              </Link>
              <Link to="/settings"
                className={`px-3 py-1.5 rounded-sm inline-flex items-center gap-2 transition-colors
                ${pathname === "/settings" ? "text-white bg-zinc-900 border border-zinc-800" : "text-zinc-400 hover:text-white"}`}>
                <SettingsIcon className="w-3.5 h-3.5" /> Pricing Defaults
              </Link>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            {right}
            {user && (
              <div className="flex items-center gap-3 pl-3 border-l border-zinc-800">
                <div className="hidden sm:block text-right">
                  <div className="text-xs font-medium text-zinc-200">{user.name || user.email}</div>
                  <div className="text-[10px] tracking-wider uppercase text-zinc-500">{user.email}</div>
                </div>
                <div className="h-8 w-8 rounded-full bg-zinc-800 overflow-hidden border border-zinc-700 flex items-center justify-center text-xs font-semibold">
                  {user.picture
                    ? <img src={user.picture} alt="" className="w-full h-full object-cover" />
                    : (user.name || user.email || "?").slice(0, 1).toUpperCase()}
                </div>
                <button
                  data-testid={AUTH.logoutBtn}
                  onClick={logout}
                  className="text-zinc-400 hover:text-white p-1.5 rounded-sm border border-transparent hover:border-zinc-800 transition-colors"
                  aria-label="Logout"
                >
                  <LogOut className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-6 py-8">{children}</main>
    </div>
  );
}
